import { render } from "./NoticeManage.vue?vue&type=template&id=a4072524"
import script from "./NoticeManage.vue?vue&type=script&lang=js"
export * from "./NoticeManage.vue?vue&type=script&lang=js"

import "./NoticeManage.vue?vue&type=style&index=0&id=a4072524&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__